const useStyles = {
  iconSmall: {
    height: 40,
  },
  iconLarge: {
    height: 40,
    paddingBottom: 2,
  },
  iconStore: {
    height: 30,
  },
};

export default useStyles;
